import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';



export const BuildStageApi = createApi({
    reducerPath: "BuildStage",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["BuildStage"],
    endpoints: (builder) => ({
        getBuildStages: builder.query({
            query: () => {
                let url = `admin/build-stages`
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ["BuildStage"],
        }),
        createBuildStage: builder.mutation({
            query: (data) => ({
                url: `admin/build-stage`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["BuildStage"],
        }),
        updateBuildStage: builder.mutation({
            query: ({ id, data }) => ({
                url: `admin/build-stage/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["BuildStage"],
        }),
        deleteBuildStage: builder.mutation({
            query: (id) => ({
                url: `admin/build-stage/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["BuildStage"],
        }),
        buildStageReorder: builder.mutation({
            query: (data) => ({
                url: `admin/build-stage/reorder`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["BuildStage"],
        }),
    }),
})

export const { useGetBuildStagesQuery, useCreateBuildStageMutation, useUpdateBuildStageMutation, useDeleteBuildStageMutation, useBuildStageReorderMutation } = BuildStageApi